export default __webpack_public_path__ + "static/media/S22SolutionsChallengeResource.479aa5fc.pdf";